module.exports = __webpack_public_path__ + "assets/501796db740ef1efab02873d2898cc5e.mp3";